export const SEARCH_COMPLAINT_BY_PHONE = "SEARCH_COMPLAINT_BY_PHONE";
export const SEARCH_COMPLAINT_BY_PHONE_SUCCESS = "SEARCH_COMPLAINT_BY_PHONE_SUCCESS";
export const SEARCH_COMPLAINT_BY_PHONE_FAILED = "SEARCH_COMPLAINT_BY_PHONE_FAILED";
